var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9956 14.4287H17.2769V11.9689C17.2769 11.0626 17.7947 10.5447 18.701 10.5447H19.9956V8.60278H17.9242C15.076 8.60278 14.817 10.9331 14.817 11.7099V14.2992H12.7456V16.2412H14.5581V25.0447H17.0179V16.2412H19.6072L19.9956 14.4287Z",
    fill: "#0079C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 30.8705C8.60261 30.8705 2.12939 24.3972 2.12939 16.4999C2.12939 8.60261 8.60261 2.12939 16.4999 2.12939C24.3972 2.12939 30.8705 8.60261 30.8705 16.4999C30.8705 24.3972 24.3972 30.8705 16.4999 30.8705ZM16.4999 3.03564C9.12047 3.03564 3.03564 9.12047 3.03564 16.4999C3.03564 23.8794 9.12047 29.9642 16.4999 29.9642C23.8794 29.9642 29.9642 23.8794 29.9642 16.4999C29.9642 9.12047 23.8794 3.03564 16.4999 3.03564Z",
    fill: "#0079C1",
    stroke: "#0079C1",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.4308e8b40c6d12afb31eba0f7c10053a.svg";
export { ForwardRef as ReactComponent };